import { memo } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IconButton, Menu, MenuButton, MenuItem, MenuList, Portal, useToast } from '@chakra-ui/react'

import config from "../../../../config/app-config";
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import { CgOptions } from "react-icons/cg";
import { displayReactIcon } from '../../../digital-sales-room/helpers/dsr-display-helpers';

function ProspectorCardOptionsButton({ 
  pDsrId, 
  dsrTitle, 
  dsrStatus, 
  isMobileView, 
  handleChangeUserActionRequired
}) {

  const toast = useToast();
  const { displayUrl } = config;


  const copyLink = () => {
    // Copy into clipboard
    const shareLink = (dsrStatus === "active" && pDsrId) ? `${displayUrl}/pdsr/access/${pDsrId}` : ""
    shareLink && navigator.clipboard.writeText(shareLink)

    toast(
      triggerLaunchdeckToast({
        label: "Link copied",
        isMobileView
      })
    )
  }

  const changeProspectorStatus = (userAction) => {
    let userActionRequired = "";
    let modalTransferPayload = ""
    switch(userAction) {
      case("unpublish-prospect-dsr-card"): {
        userActionRequired = "unpublish-prospect-dsr-card"
        modalTransferPayload = {
          pDsrId: pDsrId,
          dsrTitle: dsrTitle
        }
        break
      }
      case("publish-prospect-dsr-card"): {
        userActionRequired = "publish-prospect-dsr-card"
        modalTransferPayload = {
          pDsrId: pDsrId,
          dsrTitle: dsrTitle,
          dsrStatus
        }
        break
      }
      default: {
        break;
      }
    }

    userActionRequired && handleChangeUserActionRequired(userActionRequired, modalTransferPayload)
  }

  if (dsrStatus==="draft") {
    return null
  } else {
    return (
      <>
        <Menu isLazy placement="bottom-end" >
          <MenuButton
            as={IconButton}
            aria-label='Options'
            icon={<CgOptions />}
            variant='outline'
            size='2em'
            p='0.25em'
          />
          <Portal>
          <MenuList px='0.5em' fontSize='0.875em'>
            {(dsrStatus === "active")  && <MenuItem name='copy-link-option' className='filter-menu__dropdown-option-display' onClick={() => copyLink()} >{displayReactIcon("link","1.5em") }Copy share link</MenuItem>}
            {(dsrStatus === "active") && <MenuItem name='unpublish-room' className='filter-menu__dropdown-option-display' onClick={() => changeProspectorStatus('unpublish-prospect-dsr-card')}>{displayReactIcon("undo","1.5em") } Unpublish Prospector</MenuItem>}
            {(dsrStatus === "reverted-draft") && <MenuItem name='re-publish-room' className='filter-menu__dropdown-option-display' onClick={() => changeProspectorStatus('publish-prospect-dsr-card')}>{displayReactIcon("check","1.5em") } Republish Prospector</MenuItem>}
          </MenuList>
          </Portal>
        </Menu>
  
      </>
    );
  }
  

}


const mapStateToProps = state => ({
  isMobileView: state.mobileViewMode.isMobileView
});


export default memo(withRouter(connect(mapStateToProps, null)(ProspectorCardOptionsButton)))